import {EntityType} from "../core/entityType";
import {Operation} from "../core/operation";

export const entityType = EntityType.Assets;
export const entityOperations = [
  Operation.getAll,
  Operation.create,
];
